export default __webpack_public_path__ + "static/media/christmas5.9d1bedb6.png";